import type { Stripe } from '@stripe/stripe-js';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export let resolveStripePromise: (stripe: Stripe | null) => void;
export const stripePromise: Promise<Stripe | null> = new Promise((resolve) => {
  resolveStripePromise = resolve;
});
